module.exports = __webpack_public_path__ + "static/img/dy.e5134c73.png";